// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/app.module.scss
// module id = 22
// module chunks = 0